// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"9998b40e","552":"03639fd9","595":"e6f33292","667":"3a2cf0c5","721":"bb413427","753":"37640e98","922":"c85705f0"}[chunkId] + ".chunk.js";
};